import { useState } from 'react';

interface CtaSectionProps {
  formSubmitAddr: string;
}

export default function CtaSection({ formSubmitAddr }: CtaSectionProps) {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [statusMsg, setStatusMsg] = useState('');
  const [statusType, setStatusType] = useState<'success' | 'error' | ''>('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('website_alt') as string || '').trim();

    if (honeypot) {
      setSubmitted(true);
      setStatusType('success');
      setStatusMsg('订阅成功！感谢您的关注~');
      return;
    }

    try {
      const res = await fetch(formSubmitAddr, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          email: formData.get('email') as string,
        }).toString(),
      });
      const text = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(text); } catch (_) { /* JSON parse failed, use raw text */ }

      if (res.ok && parsed?.code === 'OK') {
        setSubmitted(true);
        setStatusType('success');
        setStatusMsg('订阅成功！新章节更新会第一时间通知你~');
        setEmail('');
      } else {
        setStatusType('error');
        setStatusMsg(parsed?.meta?.message || '订阅失败，请稍后再试');
      }
    } catch (_) {
      setStatusType('error');
      setStatusMsg('网络错误，请稍后再试');
    }
  };

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20flowing%20ink%20wash%20textures%20in%20coral%20and%20amber%20tones%2C%20modern%20minimalist%20design%2C%20soft%20artistic%20atmosphere%2C%20no%20text%20no%20characters%2C%20clean%20aesthetic&width=1600&height=600&seq=cta-subscribe-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-600/85 to-primary-700/75"></div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-3">
          追更不迷路，收藏不错过
        </h2>
        <p className="text-white/80 text-sm md:text-base mb-8">
          订阅女神漫画更新通知，新章节上线立刻送达，再也不会错过任何精彩内容
        </p>

        {submitted && statusType === 'success' ? (
          <div className="bg-white/15 backdrop-blur-sm rounded-xl py-6 px-8">
            <div className="w-14 h-14 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-500/30">
              <i className="ri-check-line text-2xl text-white"></i>
            </div>
            <p className="text-white font-medium text-lg">{statusMsg}</p>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
            data-readdy-form
          >
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入你的邮箱地址"
              required
              className="flex-1 h-12 px-5 rounded-full bg-white/15 backdrop-blur-md border border-white/20 text-white placeholder-white/50 text-sm focus:outline-none focus:border-white/40 focus:bg-white/20 transition-all"
            />
            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
            />
            <button
              type="submit"
              className="h-12 px-8 rounded-full bg-accent-500 hover:bg-accent-600 text-white font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
            >
              立即订阅
            </button>
          </form>
        )}

        {statusType === 'error' && (
          <p className="text-white/80 text-sm mt-3">{statusMsg}</p>
        )}

        <p className="text-white/50 text-xs mt-4">订阅即表示同意接收更新通知，可随时取消订阅</p>
      </div>
    </section>
  );
}